import { STATUS_LABELS, STATUS_STYLES, type CategoryMonth, type CategoryStatus } from "@/lib/budget";

export function ProgressBar({ ratio, marker, status, testId }: { ratio: number | null; marker: number; status: CategoryStatus; testId?: string }) {
  const pct = Math.min((ratio ?? 0) * 100, 100);
  return (
    <div className="relative h-2.5 w-full rounded-full bg-[#F4F5F7]" data-testid={testId}>
      <div className={`h-full rounded-full transition-[width] duration-500 ${STATUS_STYLES[status].bar}`} style={{ width: `${pct}%` }} />
      {marker > 0 && marker < 1 && (
        <span className="absolute -top-1 h-[18px] w-0.5 rounded bg-[#1B2A4A]/70" style={{ left: `${marker * 100}%` }} title="Avance del mes" />
      )}
    </div>
  );
}

export function StatusChip({ c }: { c: CategoryMonth }) {
  return (
    <div className="min-w-0">
      <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold ${STATUS_STYLES[c.status].chip}`} data-testid={`status-chip-${c.id}`}>
        {STATUS_LABELS[c.status]}
      </span>
      <p className="mt-1 truncate text-xs text-slate-500" data-testid={`helper-text-${c.id}`}>{c.helper_text}</p>
    </div>
  );
}
